/* eslint object-curly-newline: */
import { connect } from 'react-redux';
import LineChartComponent from './../Components/LineChartComponent.jsx';
import {
  getCaseMetricsScanMetrics,
  getMetricsPageHighlights,
  getCaseMetricsHitChartPointColors
} from './../reducers';
import { selectJob } from './../actions';
import { colours, chart } from './../helpers';

export const mapStateToProps = (state) => {
  const metrics = getCaseMetricsScanMetrics(state);
  const ccfData = metrics.map(m => m && m.ccf.hitCount ? m.ccf.hitCount : 0);
  const ncfData = metrics.map(m => m && m.ncf.hitCount ? m.ncf.hitCount : 0);
  const pointRadius = metrics ? 0 : 4;
  const highlights = getMetricsPageHighlights(state);
  const pointColors = getCaseMetricsHitChartPointColors(state);

  return {
    data: [ccfData, ncfData],
    series: [
      {
        backgroundColor: colours.METRICS_CHARTS.CCF_DEFAULT,
        borderColor: colours.METRICS_CHARTS.CCF_DEFAULT,
        label: 'CCF Hit Count',
        pointRadius
      },
      {
        backgroundColor: colours.METRICS_CHARTS.NCF_DEFAULT,
        borderColor: colours.METRICS_CHARTS.NCF_DEFAULT,
        label: 'NCF Hit Count',
        pointRadius,
        borderWidth: 1
      }
    ],
    labels: metrics.map(m => m ? m.jobNumber : undefined),
    pointOptions: chart.caseMetricsPointColorsToOptions(
      pointColors,
      pointColors[0] ||
        [colours.METRICS_CHARTS.CCF_DEFAULT, colours.METRICS_CHARTS.NCF_DEFAULT]
    ),
    lines: highlights,
    options: {
      scales: { xAxes: [{ offset: true }] },
      tooltips: {
        callbacks: {
          footer: (tooltipItem) => chart.metricsJobIdTooltipFooter(tooltipItem)(metrics)
        }
      }
    }
  };
};

export default connect(
  mapStateToProps,
  { onClick: selectJob }
)(LineChartComponent);


// WEBPACK FOOTER //
// src/Containers/CaseMetricsHitCountChartContainer.jsx